export const status = {
  IDLE: 'IDLE',
  SUBMITTED: 'SUBMITTED',
};

export const capitalizeText = text => {
  const capitalizeWords = text.toLowerCase().replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()));
  return capitalizeWords;
};

export const emptyManualData = {
  apartmentUnit: '',
  city: '',
  companyName: '',
  country: 'US',
  postalCode: '',
  state: '',
  street: '',
  userInputSingleLine: '',
};
